import css from '../MediaCard.module.scss';

type StatusTextProps = {
  icon: React.ReactNode;
  text: string;
};

export const StatusText = ({ icon, text }: StatusTextProps) => (
  <span className={`${css.text} ${css.pointerEventsAuto}`}>
    {icon} {text}
  </span>
);
